import './EmailScreen.scss';
import footerIcons from '../../../assets/email-footer-icons.png';
import { getUserFirstName } from "../../../utils/getUserInformation";

const Screen = ({ whiteLabelSettings, hoveredSection, RenderImage }) => {
	return (
		<div className="email-screen">
			<div className="email-screen-banner">
				{whiteLabelSettings.EmailImageFile && (
					RenderImage(whiteLabelSettings.EmailImageFile, "Email Header Preview")
				)}
			</div>
			<div className="email-screen-text">
				<h5>{whiteLabelSettings.EmailWelcomeText && whiteLabelSettings.EmailWelcomeText.replace("#", getUserFirstName())}</h5>
				<p dangerouslySetInnerHTML={{ __html: whiteLabelSettings.EmailMessageText}}></p>
			</div>

			<div className={`email-screen-cta ${hoveredSection === "colours" ? "focused" : ""}`} style={{ backgroundColor: whiteLabelSettings.EmailPrimaryColour }}>
				<p style={{ color: whiteLabelSettings.EmailTextColour }}>Get Started &gt;</p>
			</div>

			<div className="email-screen-footer" style={{ borderColor: whiteLabelSettings.EmailPrimaryColour }}>
				<p>ucSKILLS provided by iTEL</p>
				<p>www.iteluc.com | {whiteLabelSettings.EmailSupportData}{whiteLabelSettings.EmailSupportData && <> | </>}privacy policy</p>
				<img src={footerIcons} alt="Footer Icons" />
			</div>

		</div>
	);
}
export default Screen;